import React, { useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import { saveAs } from "file-saver";
import { teslaApi } from "../../../../Services/teslaApi";
import { buildBessPayload } from "../../bess/bessRequest";
import { getBlobApiErrorMessage } from "../../apiError";
import { FormValues } from "../../types";

interface BessExportButtonProps {
  values: FormValues;
  url: string;
  fileName: string;
  label: string;
}

const GENERIC_ERROR =
  "Não foi possível exportar a simulação da bateria. Tente novamente.";

export const BessExportButton = ({
  values,
  url,
  fileName,
  label,
}: BessExportButtonProps) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleExport = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await teslaApi.post(url, buildBessPayload(values), {
        responseType: "blob",
      });
      saveAs(response.data as Blob, fileName);
    } catch (e) {
      setError((await getBlobApiErrorMessage(e)) ?? GENERIC_ERROR);
    }
    setLoading(false);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <button
        type="button"
        className="simulacao-button-selected"
        onClick={handleExport}
        disabled={loading}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          {loading && <Spinner animation="border" size="sm" variant="light" />}
          {loading ? "EXPORTANDO..." : label}
        </span>
      </button>

      {error && (
        <Alert variant="danger" onClose={() => setError(null)} dismissible>
          {error}
        </Alert>
      )}
    </div>
  );
};

export const BessXlsxButton = ({ values }: { values: FormValues }) => (
  <BessExportButton
    values={values}
    url="simulator/bess/xlsx"
    fileName="resultado_bess.xlsx"
    label="EXPORTAR SIMULAÇÃO DA BATERIA (XLSX)"
  />
);

export const BessCsvButton = ({ values }: { values: FormValues }) => (
  <BessExportButton
    values={values}
    url="simulator/bess/csv"
    fileName="medicao_bess_ajustada.csv"
    label="EXPORTAR MEDIÇÃO AJUSTADA (CSV)"
  />
);
